import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const sliceI18n = createSlice({
  name: 'i18n',
  initialState: {
    loaded: false,
  },
  reducers: {
    setI18nLoaded: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, { loaded: action.payload });
    },
  },
});

export const { setI18nLoaded } = sliceI18n.actions;
export default sliceI18n.reducer;
